import videojs from 'video.js';
const registerPlugin = videojs.registerPlugin || videojs.plugin;

function muteSound(player) {
  player.soundMutedProgrammatically = true;
  player.one('volumechange', () => player.soundMutedProgrammatically = false);
  
  const videoEl = player.el().getElementsByTagName('video')[0];
  videoEl.setAttribute('muted', true);
  player.muted(true);
};

function wcrApi() {
  const player = this;
  player.muteSound = () => muteSound(player);
}

registerPlugin('wcrApi', wcrApi);

export default wcrApi;
